import React from 'react';
import { ScanLine } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-46">
          <div className="col-span-1 md:col-span-2" data-id="element-47">
            <a href="#" className="flex items-center space-x-2 mb-4" data-id="element-48">
              <div className="bg-gradient-to-br from-brand-600 to-brand-700 p-1.5 rounded-lg" data-id="element-49">
                <ScanLine className="h-5 w-5 text-white" data-id="element-50" />
              </div>
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-51">
                Intelli<span className="text-brand-500" data-id="element-52">Eats</span>
              </span>
            </a>
            <p className="text-sm max-w-xs leading-relaxed" data-id="element-53">
              Empowering you to make healthier food choices through intelligent
              ingredient analysis. Scan, detect, and eat smarter.
            </p>
          </div>

          <div data-id="element-54">
            <h3 className="text-white font-bold mb-4" data-id="element-55">Product</h3>
            <ul className="space-y-2 text-sm" data-id="element-56">
              <li data-id="element-57">
                <a href="#how-it-works" className="hover:text-brand-400 transition-colors" data-id="element-58">
                  How It Works
                </a>
              </li>
              <li data-id="element-59">
                <a href="#features" className="hover:text-brand-400 transition-colors" data-id="element-60">
                  Features
                </a>
              </li>
              <li data-id="element-61">
                <a href="#reviews" className="hover:text-brand-400 transition-colors" data-id="element-62">
                  Reviews
                </a>
              </li>
              <li data-id="element-63">
                <a href="#download" className="hover:text-brand-400 transition-colors" data-id="element-64">
                  Download
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-65">
            <h3 className="text-white font-bold mb-4" data-id="element-66">Legal</h3>
            <ul className="space-y-2 text-sm" data-id="element-67">
              <li data-id="element-68">
                <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-69">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-70">
                <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-71">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-73">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-74">
          <p data-id="element-75">© {new Date().getFullYear()} IntelliEats. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-76">Developed by Nidhi Matele</p>
        </div>
      </div>
    </footer>;
}